module.exports = __webpack_public_path__ + "img/Priest-dwarf-f-70.2d1b42b6.gif";